import type { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { RatingConfigName } from '@ils/static/enums.js';
import { type TemplateResult, html } from 'lit';

export interface RatingConfig {
  header: (host: ChemistryLitElement) => TemplateResult;
  choices: number;
  categoryWeights: [number, number, number, number];
}

export const ratingConfigs: Record<RatingConfigName, RatingConfig> = {
  '4choices': {
    header: host => html`
      <x-flex end crossaxis-center ${css({ gridColumn: '3', paddingBottom: host.spacing.sm })}>
        <x-text> trifft nicht zu </x-text>
      </x-flex>
      <x-flex end crossaxis-center ${css({ gridColumn: '4', paddingBottom: host.spacing.sm })}>
        <x-text> trifft eher nicht zu </x-text>
      </x-flex>
      <x-flex end crossaxis-center ${css({ gridColumn: '5', paddingBottom: host.spacing.sm })}>
        <x-text> trifft eher zu </x-text>
      </x-flex>
      <x-flex end crossaxis-center ${css({ gridColumn: '6', paddingBottom: host.spacing.sm })}>
        <x-text> trifft zu </x-text>
      </x-flex>
    `,
    choices: 4,
    categoryWeights: [0.075, 0.3, 0.55, 0.075],
  },
  '2choices': {
    header: host => html`
      <x-flex end crossaxis-center ${css({ gridColumn: '3 / 5', paddingBottom: host.spacing.sm })}>
        <x-text> trifft nicht zu </x-text>
      </x-flex>
      <x-flex end crossaxis-center ${css({ gridColumn: '5 / 7', paddingBottom: host.spacing.sm })}>
        <x-text> trifft zu </x-text>
      </x-flex>
    `,
    choices: 2,
    categoryWeights: [0.25, 0.25, 0.25, 0.25],
  },
};
